import React from "react"
import { ServicePageLayout } from "../../components/services/ServicePageLayout"
import { METADATA } from "../../components/meta/metadata"

export default function PartnerAIPage() {
  return (
    <ServicePageLayout
      title={METADATA.partnerAI.title}
      metaDescription={METADATA.partnerAI.description}
      backgroundImage="/images/backgrounds/flickr-32571091933.jpg"
      backgroundAlt="Partner AI"
      headline="Partner AI:<br />AI That Knows Your Organisation"
      tagline="A conversational intelligence layer trained on your institutional knowledge - not a generic chatbot, but a knowledgeable partner."
      introContent={[
        "Generic AI tools require constant prompting, correction and context-setting. They do not understand your terminology, your processes or your quality standards. Every interaction starts from scratch.",
        "Partner AI is different. Built on your Knowledge Architecture, it operates with genuine understanding of your operations. It knows your domain, speaks your language and applies your standards - like working with an experienced colleague who never forgets."
      ]}
      deliverables={[
        {
          title: "Custom Partner AI",
          description: "Conversational AI trained on your Knowledge Architecture, operating with your terminology, processes and quality standards"
        },
        {
          title: "Integration with your systems",
          description: "Connection to your existing workflows, document repositories and operational tools - Partner AI works where your teams work"
        },
        {
          title: "Governance frameworks",
          description: "Clear policies for AI use, data handling and quality assurance - responsible AI deployment from day one"
        },
        {
          title: "Team training",
          description: "Structured programmes ensuring your teams can work effectively with Partner AI and get maximum value"
        },
        {
          title: "Ongoing optimisation",
          description: "Regular refinement based on usage patterns, feedback and evolving organisational knowledge"
        }
      ]}
      benefits={[
        {
          title: "AI That Knows Your Operations",
          description: "Partner AI operates with your terminology, processes and quality standards. No constant prompting, no generic responses - it understands your context from the start."
        },
        {
          title: "Reduces Key-Person Dependency",
          description: "Institutional knowledge becomes accessible to everyone, not locked in individual heads. New team members access accumulated expertise immediately."
        },
        {
          title: "Accelerates Decision-Making",
          description: "Instant access to relevant knowledge, precedents and guidance. Teams spend less time searching and more time acting."
        },
        {
          title: "Consistency Across Operations",
          description: "Same knowledge, same standards, applied consistently. Partner AI ensures quality and approach remain uniform across teams and locations."
        }
      ]}
      audience={[
        "Organisations requiring strategic decision support",
        "Teams with complex operational knowledge to access",
        "Any sector, any operational context",
        "Leadership wanting to preserve and scale expertise",
        "Organisations seeking to reduce dependency on key individuals"
      ]}
      relatedServices={[
        {
          name: "Knowledge Engineering",
          description: "Partner AI is built on Knowledge Architecture - start here if you need the foundation",
          href: "/services/knowledge-engineering"
        },
        {
          name: "AI Kickstarter",
          description: "8-week programme that delivers Partner AI alongside strategic assessment",
          href: "/services/ai-kickstarter"
        }
      ]}
      ctaHeadline="Ready to Deploy Partner AI?"
      ctaDescription="Let's discuss how Partner AI can bring your institutional knowledge to life for your teams."
      ctaButtonText="Schedule a Consultation"
    />
  )
}
